module.exports = __webpack_public_path__ + "static/img/IMG_20160306_213801.32b412c8.jpg";